import {version } from '../../package.json';

export default {
    'npm_package_version': version
}